import React, { useState } from 'react'

import { DateInputProps, WithDateInputProps } from './interface'

export function withDateInput(Component: React.FC<DateInputProps>) {
  function WithDateInput({ onBlur, ...props }: WithDateInputProps) {
    const [actived, setActived] = useState(false)
    function handleOnFocus(e: React.FocusEvent<HTMLInputElement>) {
      setActived(true)
    }

    function handleOnBlur(e: React.FocusEvent<HTMLInputElement>) {
      setActived(false)
      if (onBlur) {
        onBlur(e)
      }
    }

    const componentProps = {
      ...props,
      actived,
      onFocus: handleOnFocus,
      onBlur: handleOnBlur,
    }

    return <Component {...componentProps} />
  }

  WithDateInput.defaultProps = {
    isError: false,
    placeholder: 'ปี/เดือน/วัน',
  }

  return WithDateInput
}
